import 'dotenv/config';
import * as css from "./HeaderHomeSplash.module.scss";

export function HeaderHomeSplash() {
  const splashUrl = new URL('../../images/splash-heart.png', import.meta.url);
  const emailAdress = process.env.ENKINDLE_EMAIL_ADDRESS_LINK;
  
  return (
      <div className={css.splash}>
        <div className={css.splashContent}>
          <h1 className={css.title}>Relationship with Jesus</h1>
          <p>Today's Christian desperately needs a heart-level experience of relationship with Jesus. Enkindle sets the stage where this deeper relationship can happen.</p>
          <a className={css.splashContentBook} href={`mailto:${emailAdress}?subject=Bring Enkindle To My Community`}>Book Enkindle Now</a>
        </div>
        <div className={css.splashPhotoBox}>
          <img className={css.splashHeart} src={splashUrl} alt="The heart before and after meeting Jesus."/>
        </div>
      </div>
    );
  }